import axios from 'axios';
import { environment } from 'environments/environment';
import { AccordionResponse } from 'types/overrides/chart';

export const getLocationVariablesAsync = async () => {
    console.log('getLocationVariablesAsync');
    let y: any[] = [];
    const getDevices = async () => {
        await axios
            .get(`${environment.apiBaseUrl}/location/variables`, {
                headers: {
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((response) => {
                console.log(response);
                // console.log(response.data.data);
                y = response.data.data;
                //return response.data.data;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };
    await getDevices();
    return y;
};

export const getLocationSNSAsync = async () => {
    console.log('getLocationSNSAsync');
    let y: any[] = [];
    const getDevices = async () => {
        await axios
            .get(`${environment.apiBaseUrl}location/sns`, {
                headers: {
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((response) => {
                console.log(response);
                // console.log(response.data.data);
                y = response.data.data;
                //return response.data.data;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };
    await getDevices();
    return y;
};

export const getLocationValuesAsync = async (requestBody: AccordionResponse) => {
    console.log('getLocationValuesAsync');
    let response: any;
    const getDeviceByID = async () => {
        await axios
            .post(`${environment.apiBaseUrl}location/values`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((res) => {
                console.log(res);
                // console.log(response.data.data);
                response = res.data.data;
                //return response.data.data;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };
    await getDeviceByID();
    return response;
};

export default getLocationVariablesAsync;
